import {
  V2Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  VisuallyHidden,
} from "web-design-system";
import { Route } from "@/routes/__root";
import { useNavigate } from "@tanstack/react-router";
import { omit } from "lodash";
import { ProposalBuilder } from "./proposal-form";
import { ProposalUIState } from "../../providers/proposal-provider";

export function ProposalsDialog() {
  const { client_id, proposal_id, goal_id, state, collection_id } =
    Route.useSearch();

  const navigate = useNavigate();

  if (!client_id) return null;

  return (
    <V2Dialog
      open
      onOpenChange={(o) =>
        !o &&
        navigate({
          to: ".",
          search: (prev) =>
            omit(prev, [
              "client_id",
              "proposal_id",
              "goal_id",
              "state",
              "modal",
            ]),
          replace: true,
        })
      }
    >
      <DialogContent
        aria-describedby={undefined}
        className="h-170 p-0 max-w-240 w-[70vw] xl:w-[60vw] xl:max-w-270 outline-0 flex flex-col overflow-hidden"
      >
        <VisuallyHidden>
          <DialogHeader>
            <DialogTitle className="text-muted-foreground font-medium">
              Create Proposal
            </DialogTitle>
          </DialogHeader>
        </VisuallyHidden>
        <ProposalBuilder
          collectionId={collection_id}
          proposalId={proposal_id}
          goalId={goal_id}
          clientId={client_id}
          state={state as ProposalUIState}
        />
      </DialogContent>
    </V2Dialog>
  );
}
